import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'

const URL = `/static/currencies`

const getCurrencies = (): AxiosPromise => apiFetch(URL)

export default getCurrencies
